import Backbone from 'backbone';


export default Backbone.Model.extend();



// WEBPACK FOOTER //
// ./static/js/models/domain.js